<template>
  <v-container fluid class="py-6">
    <v-row>
      <v-col
          v-if="false"
          md="6"
          cols="7"
          class="mx-auto text-center mb-14"
      >
        <v-tabs v-model="tab" hide-slider class="border-radius-lg">
          <v-tabs-slider></v-tabs-slider>
          <v-tab :ripple="false" class="ms-auto" href="#tab-1">
            INDIVIDUAL
          </v-tab>
          <v-tab :ripple="false" class="me-auto" href="#tab-2">
            BULK UPLOAD
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-col md="12" lg="12" cols="12">
      <v-card class="border-radius-xl overflow-hidden card-shadow h-100">
        <div
            class="
              px-4
              py-4
              d-flex
              flex-column
              justify-center
              text-center
              h-100
            "
        >
          <h5 class="text-h5 text-secondary font-weight-bold mb-2">
            Upload Bulk Records
          </h5>
          <v-row>
            <v-col
                cols="2"
                md="2"
            ></v-col>
            <v-col
                cols="8"
                md="8"
                class="align-content-center"
            >
              <input class="mt-3" type="file" ref="myFile" @change="PreviewFile" hidden>
              <v-file-input
                  @change="PreviewFile"
                  v-model="files"
                  accept=".xls , .xlsx"
                  label="Click here to upload returns"
                  multiple
                  outlined
                  class="
                           input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      border-radius-md
                      select-style
                      mt-2
                      mb-0
                        "
                  outlined
                  single-line
                  height="55"
              >
                <template v-slot:selection="{ text }">
                  <v-chip
                      small
                      label
                      color="secondary"
                      style="color: #1a252f"
                  >
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-col>
            <v-col
                cols="2"
                md="2"
            ></v-col>
          </v-row>
          <div class="w-100 justify-center mt-4">
            <v-btn
                v-if="files.length > 0"
                color="#cb0c9f"
                class="
                          font-weight-bolder
                          btn-default
                          bg-gradient-default
                          py-5
                          px-4
                        "
                small
                @click="confirmationDialog = true"
            >
              Verify Preview
            </v-btn>
          </div>
          <hr class="horizontal dark mt-4 mb-4" />
          <a
              href="#"
              class="
                      text-decoration-none
                      btn-hover
                      text-primary text-body-2
                      ls-0
                    "
              @click="DownloadSample()"
          >Download CSV Template</a>
        </div>
      </v-card>
    </v-col>
    <v-col cols="12">
      <template>
        <div>
          <v-card class="card-shadow border-radius-xl mt-6">
            <v-card-title>Preview</v-card-title>
            <v-card-text class="px-0 py-0">
              <v-data-table
                  :headers="headers"
                  :items="records"
                  :search="search"
                  class="table"
                  :page.sync="page"
                  hide-default-footer
                  @page-count="pageCount = $event"
                  :items-per-page="itemsPerPage"
                  mobile-breakpoint="0"
              >
                <template v-slot:top>
                  <v-toolbar flat height="80">
                    <v-row>
                      <v-col cols="12" md="5">
                        <v-text-field
                            hide-details
                            class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                            dense
                            flat
                            filled
                            solo
                            height="43"
                            v-model="search"
                            placeholder="Search"
                        >
                          <template slot="prepend-inner">
                            <v-icon color="#adb5bd" size=".875rem"
                            >fas fa-search</v-icon
                            >
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-toolbar>
                </template>

                <template v-slot:item.id="{ item }">
                  <div class="d-flex align-center">
                    <v-checkbox
                        :ripple="false"
                        v-model="item.checkbox"
                        color="#141727"
                    ></v-checkbox>
                    <span class="my-2 text-xs text-body font-weight-bold">{{
                        item.id
                      }}</span>
                  </div>
                </template>

                <template v-slot:item.date="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.date
              }}</span>
                </template>

                <template v-slot:item.status="{ item }">
                  <div class="d-flex align-center">
                    <v-btn
                        :ripple="false"
                        icon
                        outlined
                        rounded
                        width="25px"
                        height="25px"
                        class="me-2"
                        :class="
                  item.statusIcon == 'fas fa-check'
                    ? 'border-success'
                    : 'border-warning'
                "
                    >
                      <v-icon
                          size="8"
                          :class="
                    item.statusIcon == 'fas fa-check'
                      ? 'text-success'
                      : 'text-warning'
                  "
                      >
                        {{ item.statusIcon }}
                      </v-icon>
                    </v-btn>
                    <span class="text-body text-xs">{{ item.status }}</span>
                  </div>
                </template>

                <template v-slot:item.customer="{ item }">
                  <div class="d-flex align-center">
                    <v-avatar size="24" class="me-2" v-if="item.customerImg">
                      <v-img :src="item.customerImg"></v-img>
                    </v-avatar>

                    <v-avatar size="24" class="me-2 bg-gradient-default" v-else>
                      <span class="text-white text-xs">{{ item.customer[0] }}</span>
                    </v-avatar>
                    <span class="text-body text-xs font-weight-bold">{{
                        item.customer
                      }}</span>
                  </div>
                </template>

                <template v-slot:item.product="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.product
              }}</span>
                </template>

                <template v-slot:item.revenue="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.revenue
              }}</span>
                </template>

                <template v-slot:item.action="{ item }">
                  <v-btn
                      @click="goTo()"
                      elevation="0"
                      small
                      :ripple="false"
                      height="21"
                      class="
                    border-radius-sm
                    font-weight-bolder
                    px-2
                    py-2
                    badge-font-size
                    ms-auto
                    text-white text-xxs
                    mb-2
                  "
                      :class="
                    item.statusIcon == 'fas fa-check'
                      ? 'bg-gradient-success'
                      : 'bg-gradient-warning'
                  "
                  >{{item.statusIcon == 'fas fa-check'
                      ? 'View'
                      : 'View'}}</v-btn
                  >
                </template>

                <template v-slot:item.invoice="{ item }">
                  <v-btn
                      color="#fff"
                      class="text-dark font-weight-bolder px-1 shadow-0"
                      small
                      simple
                  >
                    <v-icon size="18" class="rotate-180"
                    >fas fa-file-pdf text-lg me-1</v-icon
                    >
                    Pdf
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions class="card-padding">
              <v-row>
                <v-col cols="6" lg="3" class="d-flex align-center">
                  <span class="text-body me-3 text-sm">Items per page:</span>
                  <v-text-field
                      hide-details
                      type="number"
                      outlined
                      min="-1"
                      max="15"
                      background-color="rgba(255,255,255,.9)"
                      color="rgba(0,0,0,.6)"
                      light
                      :value="itemsPerPage"
                      @input="itemsPerPage = parseInt($event, 10)"
                      placeholder="Items per page"
                      class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
              "
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="ml-auto d-flex justify-end">
                  <v-pagination
                      prev-icon="fa fa-angle-left"
                      next-icon="fa fa-angle-right"
                      class="pagination"
                      color="#cb0c9f"
                      v-model="page"
                      :length="pageCount"
                      circle
                  ></v-pagination>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </div>
      </template>
    </v-col>
      <v-tabs-items v-if="false" v-model="tab">
        <v-tab-item value="tab-1" >
          <v-col md="12" lg="12" cols="12" >
            <v-card class="card-shadow border-radius-xl h-100">
              <div class="px-4 pt-4">
                <h6 class="mb-0 text-h6 text-typo font-weight-bold">Add Record</h6>
              </div>
              <div class="px-4 pt-4">
                <v-row class="mt-2">
                  <v-col sm="6" cols="12">
                    <label class="text-xs text-typo font-weight-bolder ms-1"
                    >Organisation</label
                    >
                    <v-select
                        @change="onGradeChange()"
                        label="Select Organisations"
                        :items="organisations"
                        item-text="COMPANY"
                        item-value="id"
                        v-model="organisation"
                    ></v-select>
                  </v-col>
                  <v-col sm="6" cols="12">
                    <label class="text-xs text-typo font-weight-bolder ms-1"
                    >Weeks Numbers</label
                    >
                    <v-text-field
                        v-model="week_range"
                        hide-details
                        outlined
                        type="text"
                        color="rgba(0,0,0,.6)"
                        light
                        placeholder="21-26/2024"
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-2">
                  <v-col sm="6" cols="12">
                    <label class="text-xs text-typo font-weight-bolder ms-1"
                    >Payment Method</label
                    >
                    <v-text-field
                        v-model="payment_type"
                        hide-details
                        outlined
                        color="rgba(0,0,0,.6)"
                        light
                        placeholder="eg. TRANSFER"
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                    >
                    </v-text-field>
                  </v-col>
                  <v-col sm="6" cols="12">
                    <label class="text-xs text-typo font-weight-bolder ms-1"
                    >Other</label
                    >
                    <v-text-field
                        v-model="other"
                        hide-details
                        outlined
                        type="number"
                        color="rgba(0,0,0,.6)"
                        light
                        placeholder="eg. 1000"
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-2">
                  <v-col sm="6" cols="12">
                    <label class="text-xs text-typo font-weight-bolder ms-1"
                    >General Fund</label
                    >
                    <v-text-field
                        v-model="general_fund"
                        hide-details
                        outlined
                        type="number"
                        color="rgba(0,0,0,.6)"
                        light
                        placeholder="eg. 89099"
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                    >
                    </v-text-field>
                  </v-col>
                  <v-col sm="6" cols="12">
                    <label class="text-xs text-typo font-weight-bolder ms-1"
                    >Interest</label
                    >
                    <v-text-field
                        v-model="interest"
                        hide-details
                        outlined
                        type="number"
                        color="rgba(0,0,0,.6)"
                        light
                        placeholder="eg. 300"
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-2">
                  <v-col sm="6" cols="12">
                    <label class="text-xs text-typo font-weight-bolder ms-1"
                    >Unallocated Amount</label
                    >
                    <v-text-field
                        v-model="unallocated_amount"
                        hide-details
                        outlined
                        type="number"
                        color="rgba(0,0,0,.6)"
                        light
                        placeholder="eg. 678989"
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                    >
                    </v-text-field>
                  </v-col>
                  <v-col sm="6" cols="12">
                    <label class="text-xs text-typo font-weight-bolder ms-1"
                    >Total</label
                    >
                    <v-text-field
                        v-model="total_amount"
                        hide-details
                        outlined
                        type="number"
                        color="rgba(0,0,0,.6)"
                        light
                        placeholder="eg. 1"
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-2">
                  <v-col sm="6" cols="12">
                    <label class="text-xs text-typo font-weight-bolder ms-1"
                    >Currency</label
                    >
                    <v-select
                        label="Select Currency"
                        :items="['USD','ZiG']"
                        v-model="currency"
                    ></v-select>
                  </v-col>
                  <v-col sm="6" cols="12">
                    <label class="text-xs text-typo font-weight-bolder ms-1"
                    >Date Paid</label
                    >
                    <v-text-field
                        v-model="date_received"
                        hide-details
                        outlined
                        type="date"
                        color="rgba(0,0,0,.6)"
                        light
                        placeholder="eg. 678989"
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                    >
                    </v-text-field>
                  </v-col>

                </v-row>
                <v-row>
                  <v-col lg="5" cols="5">
                  </v-col>
                  <v-col lg="4" cols=4>
                    <div class="w-40 text-center ml-5 mt-5 pb-5" >
                      <v-btn
                          color="#cb0c9f"
                          class="
                  font-weight-bolder
                  btn-default
                  bg-gradient-default
                  py-5
                  px-4
                "
                          large
                      >
                        Add To Ledger
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col lg="2" cols="2">
                  </v-col>

                </v-row>
              </div>

            </v-card>
          </v-col>
        </v-tab-item>
        <v-tab-item value="tab-2">

        </v-tab-item>
      </v-tabs-items>
    <v-dialog
        v-model="confirmationDialog"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Confirm Upload
        </v-card-title>

        <v-card-text>
          Are you sure you want to upload this file ?
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="green darken-1"
              text
              outlined
              @click="confirmationDialog = false; AddRecords()"
          >
            Yes
          </v-btn>
          <v-btn
              color="red darken-1"
              text
              outlined
              @click="confirmationDialog = false"
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="successDialog"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Success
        </v-card-title>

        <v-card-text>
          Your upload has been done
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="green darken-1"
              text
              outlined
              @click="goTo()"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="errorDialog"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Error
        </v-card-title>

        <v-card-text>
          There was an error adding your returns
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="danger darken-1"
              text
              outlined
              @click="errorDialog = false"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="errorUpload3"
        persistent
        width="350"
    >
      <v-card>
        <v-toolbar
            dark
            color="primary"
        >
          <v-toolbar-title  v-if="true">
            <h3 class="text-center justify-center">Data Error</h3>

          </v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <div class="text-center justify-center">
          <br>
          <h2
              class="pt-6"
              style="color: #800808;"
          >
            {{ ECRefError }}
          </h2>
          <v-row class="mr-2 ml-2 pt-0 pb-0">
            <v-col
                sm="12"
                md="12"
                lg="12"
            >
              <v-card-actions
                  class="justify-center"
              >
              </v-card-actions>
            </v-col>
            <v-col
                sm="12"
                md="12"
                lg="12"
            >
              <v-card-actions
                  class="justify-center"
              >
                <v-btn
                    color="red darken-1"
                    @click="errorUpload3 = false, records = [], files = []"
                >
                  Resubmit
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            size="64"
        />
      </v-overlay>
    </div>
  </v-container>
</template>
<script>
import ReportsTable from "./Widgets/ReportsTable.vue";
import Dropzone from "@/views/Client/Products/Widgets/Dropzone";
import * as XLSX from "xlsx/xlsx";
import axios from "axios";
import {mapState} from "vuex";
import moment from 'moment'

export default {
  name: "Dashboard",
  data() {
    return {
      picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      overlay: false,
      fileSingle: [],
      page: 1,
      confirmationDialog: false,
      currency: "ZiG",
      tab: null,
      successDialog: false,
      errorDialog: false,
      errorUpload3: false,
      files:[],
      pageCount: 0,
      itemsPerPage: 10,
      search: "",
      payment_type:"",
      week_range:"",
      general_fund: "",
      other:"",
      unallocated:"",
      interest:"",
      organisations: [],
      records: [],
      headers: [
        {
          text: "Company Name",
          value: "CompanyName",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Week Range",
          value: "WeekNumber",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Date Received",
          value: "DateReceived",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "General Fund",
          value: "GeneralFund",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Total Amount",
          value: "Total",
          class: "text-secondary font-weight-bolder opacity-7",
        },


      ],
    };
  },
  components: {
    ReportsTable,
    Dropzone,
  },
  computed: {
    ...mapState(['base_url', 'OrgId', 'isAuthenticated']),
  },
  created () {
    this.getOrgs()
    if (!this.isAuthenticated && this.is_admin) {
      this.$router.push("/login");
    }
    // else{
    //
    // }
  },
  methods: {
    onGradeChange(){
      if(this.grade === "Grade 1"){
        this.general_fund = 10.01
      }else if(this.grade === "Grade 2"){
        this.general_fund = 20.20
      }else if(this.grade === "Grade 3"){
        this.general_fund = 30.03
      }
      else if(this.grade === "Grade 4"){
        this.general_fund = 40.14
      }
    },
    goTo(){
      this.$router.push("/admin-zig-ledgers");
    },
    async PreviewFile(){
      this.overlay = true
      if(this.files.length > 0) {
        let file = this.files[0]
        let FileExt = file.name.split('.')[1]
        if (FileExt == 'xlsx') {
          const reader = new FileReader();
          const that = this
          reader.onload = function (e) {
            const data = e.target.result;
            const workbook = XLSX.read(data, {
              type: 'binary'
            });
            workbook.SheetNames.forEach(function (sheetName) {
              // Here is your object
              const XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
              const json_object = JSON.stringify(XL_row_object);
              // console.log(json_object);
              // XL_row_object.forEach((node) => node.date_received = node.Date);
              // XL_row_object.forEach((node) => node.week_range = node.WeekNumber);
              // XL_row_object.forEach((node) => node.company_name = node.CompanyName);
              // XL_row_object.forEach((node) => node.payment_type = node.PaymentMethod );
              // XL_row_object.forEach((node) => node.other = node.Other );
              // XL_row_object.forEach((node) => node.general_fund = node.GeneralFund );
              // XL_row_object.forEach((node) => node.interest = node.Interest );
              // XL_row_object.forEach((node) => node.unallocated_amount = node.UnallocatedAmount );
              // XL_row_object.forEach((node) => node.total_amount = node.Total);
              XL_row_object.forEach((node) => that.sanitizeXslSDate(node.DateReceived));
              that.records = XL_row_object;
              console.log(that.records)
              return json_object;
            })

          };
          reader.onerror = function (ex) {
            console.log(ex);
          };
          reader.readAsBinaryString(file);
        } else {
          this.overlay = false;
          this.valid = false;
          this.errorUpload2 = true;
        }
      }
      else{
        this.records = []
        this.overlay = false
        this.errorUpload = true
      }
      this.overlay = false
    },
    SanitizeAmountToGrade(val){
      console.log("item",this.grades[0][val])
      let amount = this.grades[0][val]
      return amount
    },
    sanitizeXslSDate(val){
      // let year = val.substring(4,8);
      // let month = val.substring(2,4)
      // let day = val.substring(0,2)
      // const d = new Date('2019/06/01');
      let invalidity = false
      let res = moment(val).format('YYYY-MM-DD');
      if(res == 'Invalid date'){
        invalidity = true
      }
      if(res == '01/Jan/1970'){
        invalidity = true
      }
      if (invalidity){
        this.ECRefError = "You have an invalid date of  - " + val;
        this.errorUpload3 = true;
      }
      return res;
    },
    async AddRecords() {
      let JWTToken = this.$store.getters.accessToken;
      console.log(this.$store.getters.accessToken);
      this.overlay = true;
      const config = {
        method: "post",
        url: this.base_url + "/ledger/submit-records/" + this.currency,
        data: this.records,
        headers: {Authorization: `Bearer ${JWTToken}`}
      };
      axios(config)
          .then((response) => {
            if (response.status === 201) {
              console.log(response.data)
              this.overlay = false;
              this.successDialog = true;
            }
          })
          .catch((error) => {
            console.log(error)
            if (error.status === 400) {
              this.overlay = false;
              this.errorDialog = true;
            }
            else {
              this.overlay = false;
              this.errorDialog = true;
            }
          });
      this.overlay = false;
    },
    async AddSingleRecord() {
      let JWTToken = this.$store.getters.accessToken;
      console.log(this.$store.getters.accessToken);
      this.overlay = true;
      let recordData = {
        "week_range": this.week_range,
        "date_received": this.date_received,
        "organisation_id": this.organisation,
        "payment_type": this.payment_type,
        "other": this.other,
        "general_fund": this.general_fund,
        "interest": this.interest,
        "total_amount": this.total_amount,
        "unallocated_amount": this.unallocated_amount,
        "currency": this.currency
      }
      const config = {
        method: "post",
        url: this.base_url + "/ledger/submit-record/",
        data: recordData,
        headers: {Authorization: `Bearer ${JWTToken}`}
      };
      axios(config)
          .then((response) => {
            if (response.status === 201) {
              console.log(response.data)
              this.overlay = false;
              this.successDialog = true;
            }
          })
          .catch((error) => {
            console.log(error)
            if (error.status === 400) {
              this.overlay = false;
              this.errorDialog = true;
            }
            else {
              this.overlay = false;
              this.errorDialog = true;
            }
          });
      this.overlay = false;
    },

    GenerateBatchID(val){
      const TodayDate = moment().format("YYMMDDms");
      const BatchID = "NEC" + TodayDate + val.length
      return BatchID;
    },
    async getOrgs(){
        const JWTToken = this.$store.getters.accessToken
        axios.get(this.base_url + '/auth/get-company-register/', {
              headers: {
                Authorization: `Bearer ${JWTToken}`
              }
            })
            .then(res => {
              if (res.status === 200) {
                this.organisations = res.data
                console.log(this.grades)
              } else if (res.status === 401) {
                next("/login")
              }

              else {
                console.log('error')
              }
            })
    },

    async DownloadSample() {
      this.overlay = true
      await this.DownloadFN()
      this.overlay = false
    },
    async DownloadFN(){
      window.location.href = this.base_url + "/media/batches_template.xlsx";
    },



  },
};
</script>
